import { ThunkDispatch } from "core-integration/src/store";
import { IElementsById } from "core-integration/src/store/elements/types";
import { IAutomaticSub } from "core-integration/src/store/entries/types";
import { getCurrentEventStatus } from "core-integration/src/store/events/reducers";
import { fetchEventStatus } from "core-integration/src/store/events/thunks";
import { IEvent } from "core-integration/src/store/events/types";
import { Cell, Column, Table } from "plos/src/components/Table";
import { Alert } from "plos/src/components/alerts";
import InfoIcon from "plos/src/img/icons/info.svg?react";
import { useEffect } from "react";
import { Row, TableBody, TableHeader } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { formatDateAsLocal } from "shared-utils/src/datetime";
import { getGameweekFinalTime } from "../utils";
import styles from "./Autosubs.module.css";

interface AutosubsProps {
  automaticSubs: IAutomaticSub[];
  elementsById: IElementsById;
  event: IEvent;
}

const Autosubs = ({ automaticSubs, elementsById, event }: AutosubsProps) => {
  const { t } = useTranslation("points");

  const dispatch = useDispatch<ThunkDispatch>();

  useEffect(() => {
    dispatch(fetchEventStatus());
  }, [dispatch]);

  const statusData = useSelector(getCurrentEventStatus);

  const gameweekFinalTime =
    statusData && getGameweekFinalTime(statusData.status);
  const gameweekFinalDate = gameweekFinalTime
    ? formatDateAsLocal(gameweekFinalTime)
    : undefined;

  return (
    <>
      {automaticSubs.length > 0 ? (
        <div className={styles.autoSubsWrapper}>
          <h2>{t("automaticSubs", "Automatic Substitutions")}</h2>
          <Table aria-label={t("automaticSubs", "Automatic Substitutions")!}>
            <TableHeader>
              <Column isRowHeader>{t("playerOut", "Player out")}</Column>
              <Column>{t("playerIn", "Player in")}</Column>
            </TableHeader>
            <TableBody>
              {automaticSubs.map((s) => (
                <Row key={s.element_out}>
                  <Cell>{elementsById[s.element_out].web_name}</Cell>
                  <Cell>{elementsById[s.element_in].web_name}</Cell>
                </Row>
              ))}
            </TableBody>
          </Table>
        </div>
      ) : (
        event.finished === false &&
        gameweekFinalDate && (
          <Alert icon={<InfoIcon />}>
            {t(
              "automaticSubsInfo",
              "Gameweek points are still provisional. Once the Gameweek is marked as final on {{gameweekFinalDate}}, autosubs will then be processed and points and ranks updated accordingly.",
              { gameweekFinalDate: gameweekFinalDate },
            )}
          </Alert>
        )
      )}
    </>
  );
};

export default Autosubs;
